import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;

  display: flex;
  flex-wrap: wrap;
  gap: 48px;

  align-items: center;

  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray[600]};

  @media (max-width: 700px) {
    gap: 8px;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 30px;
  margin-right: 16px;
  align-items: center;

  @media (max-width: 700px) {
    gap: 12px;
    margin-right: 0;
  }

  button {
    border: none;
    background: none;

    svg {
      stroke: ${({ theme }) => theme.colors.orange.primary};
    }

    &:disabled {
      cursor: not-allowed;

      svg {
        stroke: ${({ theme }) => theme.colors.gray[500]};
      }
    }
  }
`;
